var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (escapeAttr, group, rows) {
jade_mixins["mixinHeadCell"] = jade_interp = function(cell, escapeAttr){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = escapeAttr(cell.attributes)
buf.push("<th" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
if ( (cell.html))
{
buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
}
else
{
buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
}
buf.push("</th>");
};
jade_mixins["mixinCell"] = jade_interp = function(cell, escapeAttr){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = escapeAttr(cell.attributes)
buf.push("<td" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([cell.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
if ( (cell.html))
{
buf.push(null == (jade_interp = cell.html) ? "" : jade_interp);
}
else
{
buf.push(jade.escape(null == (jade_interp = cell.value) ? "" : jade_interp));
}
buf.push("</td>");
};
jade_mixins["mixinRow"] = jade_interp = function(row, group, escapeAttr){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var attr = escapeAttr(row.attributes)
buf.push("<tr" + (jade.attrs(jade.merge([{"class": (jade_interp = [true], jade.joinClasses([row.classes].map(jade.joinClasses).map(function (cls, i) {   return jade_interp[i] ? jade.escape(cls) : cls })))},attr]), true)) + ">");
// iterate row.cells || []
;(function(){
  var $$obj = row.cells || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var cell = $$obj[$index];

switch (group){
case 'head':
jade_mixins["mixinHeadCell"](cell, escapeAttr);
  break;
case 'body':
case 'foot':
jade_mixins["mixinCell"](cell, escapeAttr);
  break;
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var cell = $$obj[$index];

switch (group){
case 'head':
jade_mixins["mixinHeadCell"](cell, escapeAttr);
  break;
case 'body':
case 'foot':
jade_mixins["mixinCell"](cell, escapeAttr);
  break;
}
    }

  }
}).call(this);

buf.push("</tr>");
};
jade_mixins["mixinRows"] = jade_interp = function(rows, group, escapeAttr){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate rows || []
;(function(){
  var $$obj = rows || [];
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var row = $$obj[$index];

jade_mixins["mixinRow"](row, group, escapeAttr);
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var row = $$obj[$index];

jade_mixins["mixinRow"](row, group, escapeAttr);
    }

  }
}).call(this);

};
jade_mixins["mixinRows"](rows, group, escapeAttr);}.call(this,"escapeAttr" in locals_for_with?locals_for_with.escapeAttr:typeof escapeAttr!=="undefined"?escapeAttr:undefined,"group" in locals_for_with?locals_for_with.group:typeof group!=="undefined"?group:undefined,"rows" in locals_for_with?locals_for_with.rows:typeof rows!=="undefined"?rows:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/layout/header-footer.jade
// module id = 95
// module chunks = 0